<template>
    <div class="page-consume" v-loading.body="fullLoading">
        <div class="game-info" v-loading.body="appLoading">
            <template v-if="appList.length > 0 && !appLoading">
                  <div class="method-container">
                      <div class="method-select game-list">
                          <div class="swiper-button-prev" slot="button-prev"></div>
                          <swiper :options="consumeSwiper">
                              <swiper-slide class="game-item" v-for="(app,appIndex) in appList">
                                  <img :src="app.iconUrl" class="game-logo"
                                       :class="{ 'app-active': selectedAppIndex == appIndex }" @click="selectedAppIndex = appIndex">
                                  <div class="game-name">{{ app.appName }}</div>
                              </swiper-slide>
                          </swiper>
                          <div class="swiper-button-next" slot="button-next"></div>
                      </div>
                  </div>
                    <!--<li class="game-item" v-for="(app,appIndex) in appList" @click="selectedAppIndex = appIndex">-->
                        <!--<img :src="app.iconUrl" class="game-logo"-->
                             <!--:class="{ 'app-active': selectedAppIndex == appIndex }">-->
                        <!--<div class="game-name">{{ app.appName }}</div>-->
                    <!--</li>-->
            </template>
            <template v-if="appList.length == 0 && !appLoading">
                <p class="no-game">{{ $t('noGames') }}</p>
            </template>
        </div>

        <div class="goods-content" v-if="appList.length > 0 && !appLoading" v-loading.body="goodsLoading">
            <template v-if="goodsList.length > 0 && !goodsLoading">
                <div class="goods-list">
                    <div v-for="(goods, goodsIndex) in goodsList" @click="selectedGoodsIndex = goodsIndex"
                         class="goods-item" :class="{'goods-active': selectedGoodsIndex == goodsIndex}">
                        <div class="goods-name">{{ goods.goodsName }}</div>
                        <div class="goods-price">
                            {{ Math.ceil(goods.price * 100) }} {{ $t('egPoint') }}
                        </div>
                        <div class="goods-select-mark">
                            <i class="el-icon-check"></i>
                        </div>
                    </div>
                </div>
                <el-button type="primary" @click="checkIsPlayedGame" class="buy-btn">{{ $t('purchase') }}
                </el-button>
            </template>
            <template v-if="goodsList.length == 0 && !goodsLoading">
                <div class="no-goods">{{ $t('noGoods') }}</div>
            </template>
        </div>

        <popup :title="$t('confirmOrder')" v-if="showConsume" @close="closePopup" id="popup" :showHeader="true"
               :showPopupLoading="popupLoading">
            <el-form :model="goodsOrder" label-width="120px">
                <el-form-item :label="$t('goodsName')">
                    <el-input v-model="goodsOrder.goodsName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('goodsPrice')">
                    <el-input v-model="goodsOrder.goodsPrice" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('gameArea')" v-if="gamePlayed && goodsInfo.appId == 1005">
                    <el-select v-model="areaId" :placeholder="$t('gameArea')" @change="getServerList">
                        <el-option
                                v-for="(areaName, areaId) in areaList"
                                :label="areaName"
                                :value="areaId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <template v-if="gamePlayed">
                    <el-form-item :label="$t('gameServer')">
                        <el-select v-model="serverId" :placeholder="$t('selectGameServer')"
                                   @change="getRoleInfo" icon="loading">
                            <el-option
                                    v-for="server in serverList"
                                    :label="server.serv_name"
                                    :value="server.serv_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('roleName')">
                        <el-select v-model="roleIndex" placeholder="" :disabled="roles.length > 1 ? false : true" v-if="roles.length > 0 && roles[0].roleName">
                            <el-option
                                    v-for="(role,roleIndex) in roles"
                                    :label="role.roleName"
                                    :value="roleIndex">
                            </el-option>
                        </el-select>
                        <el-input :value="$t('noRoleMsg')" :disabled="true" v-else></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('loginPassword')">
                        <el-input v-model.trim="goodsOrder.password" type="password"></el-input>
                    </el-form-item>
                </template>

                <div class="btns">
                    <el-button type="primary" @click="validate" v-if="gamePlayed">{{ $t('confirmBuy') }}</el-button>
                    <a class="el-button el-button--primary" :href="appList[this.selectedAppIndex].appDownload"
                       v-if="!gamePlayed">{{ $t('downloadGame') }}</a>
                    <el-button @click="closePopup">{{ $t('cancelBuy') }}</el-button>
                </div>
            </el-form>
        </popup>
    </div>
</template>

<script>
    import Popup from '../partial/Popup.vue'
    import {Loading} from 'element-ui'
    import {swiper, swiperSlide, swiperPlugins} from 'vue-awesome-swiper'
    import * as types from '../../store/mutation-types'

    export default {
        data() {
            return {
                appLoading: false,
                selectedAppIndex: 0,

                goodsLoading: false,
                goodsList: [],
                selectedGoodsIndex: 0,

                userPlayedApp: [],
                fullLoading: false,

                showConsume: false,
                serverList: [],

                popupLoading: true,

                areaId: '1',
                serverId: '',
                roleIndex: 0,
                roles: []
            };
        },
        computed: {
            roleInfo() {
                if (this.roles.length > 0 && this.roles[0].roleName) {
                    return this.roles[this.roleIndex];
                }
                return [
                    {
                        roleName: '',
                        roleId: '',
                        payDescription: '',
                        cpUid: ''
                    }
                ];
            },
            appList() {
                return this.$store.state.consume.appList;
            },
            appId() {
                if (this.appList.length === 0) {
                    return '';
                }
                return parseInt(this.appList[this.selectedAppIndex].id);
            },
            areaList() {
                return this.$store.getters.areaList;
            },
            gamePlayed() {
                return this.userPlayedApp.indexOf(this.appId) > -1;
            },
            goodsInfo() {
                return this.goodsList[this.selectedGoodsIndex];
            },
            goodsOrder() {
                return {
                    areaId: this.areaId,
                    goodsName: this.goodsInfo.goodsName,
                    goodsPrice: Math.ceil(this.goodsInfo.price * 100),
                    goodsId: this.goodsInfo.goodsId,
                    serverId: this.serverId,
                    roleName: this.roleInfo.roleName,
                    roleId: this.roleInfo.roleId,
                    password: '',
                    appId: this.goodsInfo.appId,
                    appName: this.appList[this.selectedAppIndex].appName,
                    uid: this.$store.state.user.uid,
                    payDescription: this.roleInfo.payDescription,
                    cpUid: this.roleInfo.cpUid
                }
            },
            consumeSwiper() {
                return {
                    slidesPerView: 4,
                    paginationClickable: true,
                    spaceBetween: 30,
                    freeMode: true,
                    preventClicks: false,
                    nextButton: '.swiper-button-next',
                    prevButton: '.swiper-button-prev'
                }
            },
        },
        watch: {
            appId(appId) {
                this.selectedGoodsIndex = 0;
                this.goodsList = [];
                this.serverList = [];
                this.areaId = '1';
                this.roleIndex = 0;
                this.roles = [];
                if (appId) {
                    this.getGoodsList();
                }
            }
        },
        components: {
            Popup,
            swiper,
            swiperSlide
        },
        methods: {
            getAppList() {
                if (this.$store.state.consume.appList.length > 0) {
                    return;
                }

                const that = this;
                this.appLoading = true;
                this.$store.dispatch([types.GET_APP_LIST]).then(() => {
                    that.appLoading = false;
                }).catch((errorCode) => {
                    that.appLoading = false;
                    that.$message.error('Get games failed: ' + errorCode);
                });
            },
            getGoodsList() {
                if (!this.appId) {
                    return;
                }

                let goods = this.$store.state.consume.goodsList;
                if (goods[this.appId]) {
                    this.goodsList = goods[this.appId];
                    return;
                }

                const that = this;
                this.goodsLoading = true;
                this.$store.dispatch([types.GET_GOODS_LIST], this.appId).then((goodsList) => {
                    that.goodsList = goodsList;
                    that.goodsLoading = false;
                }).catch((errorCode) => {
                    that.goodsLoading = false;
                    that.$message.error('Get goods failed: ' + errorCode);
                });
            },
            //检查用户使用玩过该游戏
            checkIsPlayedGame() {
                this.goodsOrder = {
                    areaId: '1',
                    goodsName: '',
                    goodsPrice: '',
                    goodsId: '',
                    serverId: '',
                    roleName: '',
                    roleId: '',
                    password: '',
                    appId: '',
                    appName: '',
                    uid: this.$store.state.user.uid,
                    payDescription: '',
                    cpUid: ''
                };
                //检查用户是否登录
                const isLogin = Boolean(this.$store.state.user.accessToken);
                if (!isLogin) {
                    return this.$store.commit('controlLoginPopup', true);
                }

                const that = this;
                this.getUserPlayedApp().then(() => {
                    that.showConsume = true;
                    if (that.gamePlayed) {
                        that.getServerList();
                    } else {
                        that.popupLoading = false;
                    }
                });
            },
            getUserPlayedApp() {
                return new Promise((resolve, reject) => {
                    if (this.$store.getters.playedGamesList.length > 0) {
                        this.userPlayedApp = this.$store.getters.playedGamesList;
                        resolve();
                        return;
                    }

                    this.fullLoading = true;
                    const that = this;
                    let apiParams = {
                        uid: this.goodsOrder.uid,
                        accessToken: this.$store.state.user.accessToken
                    };

                    that.$store.dispatch([types.GET_USER_PLAYED_GAME], apiParams).then(() => {
                        that.userPlayedApp = that.$store.getters.playedGamesList;
                        that.fullLoading = false;
                        resolve();
                    }).catch(() => {
                        that.fullLoading = false;
                        that.$message.error('Get played games failed: ' + errorCode);
                        reject();
                    });
                });
            },
            getServerList() {
                this.serverId = '';
                this.serverList = [];
                this.roleInfo = {};
                let serverList = this.$store.state.consume.serverList;
                if (serverList[this.appId] && serverList[this.appId][this.goodsOrder.areaId]) {
                    this.serverList = serverList[this.appId][this.goodsOrder.areaId];
                    return;
                }

                this.popupLoading = true;
                let apiParams = {
                    uid: this.goodsOrder.uid,
                    appId: this.appId,
                    areaId: this.goodsOrder.areaId
                };
                const that = this;
                this.$store.dispatch([types.GET_SERVER_LIST], apiParams).then((serverList) => {
                    that.serverList = serverList;
                    that.popupLoading = false;
                }).catch((errorCode) => {
                    that.popupLoading = false;
                    that.$message.error('Get server list failed');
                });

            },
            getRoleInfo() {
                this.roles = [];

                this.popupLoading = true;
                if (!this.goodsOrder.serverId) {
                    return;
                }
                let apiParams = {
                    uid: this.goodsOrder.uid,
                    appId: this.appId,
                    serverId: this.goodsOrder.serverId,
                    areaId: this.goodsOrder.areaId,
                    cpUid: this.$store.state.user.shortUid,
                    token: this.$store.state.user.accessToken,
                };
                const that = this;
                this.$store.dispatch([types.GET_ROLE_INFO], apiParams).then((userInfo) => {
                    that.popupLoading = false;
                    if (userInfo.length > 0 && userInfo[0].roleName) {
                        that.roles = userInfo;
                    } else {
                        that.$message.warning(this.$t('noRoleInServer'));
                    }
                }).catch((errorCode) => {
                    that.popupLoading = false;
                    that.$message.error('Get role info failed');
                });
            },
            validate() {
                if (!this.goodsOrder.roleId) {
                    this.$message.warning(this.$t('noRoleInServer'));
                    return;
                }
                if (!this.goodsOrder.password) {
                    this.$message.warning(this.$t('pleaseInputPassword'));
                    return;
                }
                this.egPay();
            },
            egPay() {
                this.popupLoading = true;
                const that = this;

                let params = this.goodsOrder;
                params.token = this.$store.state.user.accessToken;
                this.$store.dispatch([types.EG_BUY_GOODS], params).then((apiResult) => {
                    that.popupLoading = false;
                    if (apiResult === -1) {
                        that.$message.error(that.$t('createGoodsOrderFail'));
                    } else {
                        let result = apiResult;
                        if (parseInt(result.code) === 0) {
                            that.showConsume = false;
                            that.$store.commit('getTotalEg');
                            that.$alert(that.$t('buyGoodsSuccess'), that.$t('buyGoodsSuccess'), {
                                confirmButtonText: that.$t('confirm'),
                            });
                            this.roles = [];
                        } else {
                            that.showConsume = false;
                            switch (parseInt(result.code)) {
                                case -1:
                                    that.$alert(that.$t('systemErrorTryLater'), that.$t('buyGoodsFail'));
                                    break;
                                case 2002:
                                    that.$alert(that.$t('userNotExits'), that.$t('buyGoodsFail'));
                                    break;
                                case 2007:
                                    that.$alert(that.$t('passwordError'), that.$t('buyGoodsFail'));
                                    break;
                                case 4003:
                                    that.$alert(that.$t('egPointNotEnough'), that.$t('buyGoodsFail'));
                                    break;
                                case 2019:
                                    that.$alert(that.$t('isBlocked'), that.$t('buyGoodsFail'));
                                    break;
                                default:
                                    that.$alert(that.$t('buyGoodsFailErrorCode') + parseInt(result.code), that.$t('buyGoodsFail'), {
                                        confirmButtonText: that.$t('confirm'),
                                    });
                            }
                            this.roles = [];
                        }
                    }
                }).catch(() => {
                    that.popupLoading = false;
                    that.$message.error(that.$t('networkError'));
                    this.roles = [];
                });
            },
            closePopup() {
                this.roles = [];
                this.showConsume = false;
                document.body.style.overflow = 'auto';
            }
        },
        created() {
            this.getAppList();
            this.getGoodsList();
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .page-consume {
        .el-form-item {
            margin-bottom: 15px !important;
        }
    }

    .no-goods, .no-game {
        color: $orange-color;
        font-size: 18px;
    }

    .game-info {
        height: 230px;
        overflow: hidden;
        @include flex-row-center;
    }

    .game-list {
        border-bottom: 1px solid $blue-color;
        width: 750px;
        overflow: hidden;
        @include flex-row-center;
        margin: 0 auto 50px;
        padding-bottom: 30px;
        .game-item {
            height: 150px;
            width: 150px;
            @include flex-column-center;
            @include flex-grow(0);
            overflow: hidden;
            .app-active {
                border: 5px solid $blue-color !important;
            }
            .game-logo {
                width: 120px;
                height: 120px;
                border-radius: 27px;
                border: 5px solid #fff;
                &:hover {
                    border: 5px solid $blue-color;
                    cursor: pointer;
                }
            }
            .game-name {
                height: 20px;
                margin-top: 10px;
                font-size: 14px;
                text-align: center;
            }
        }
    }

    .goods-content {
        margin: 0 auto;
        .no-goods {
            @include flex-row-center;
        }
    }

    .select-goods {
        font-size: 20px;
        margin: 20px 0;
    }

    $goods-item-width: 170px;
    $goods-item-height: 80px;
    $goods-item-margin: 20px;
    $goods-list-width: 170px * 3 + 20px * 6 + 17.5px;

    .goods-list {
        width: $goods-list-width;
        @include flex;
        @include flex-wrap;
        margin: 0 auto;
        padding-left: 15px;
    }

    .goods-item {
        height: $goods-item-height;
        width: $goods-item-width;
        position: relative;
        @include flex-column-center;
        border: 1px solid $blue-color;
        border-radius: 10px;
        margin: $goods-item-margin;
        cursor: pointer;
        overflow: hidden;
        &:hover {
            border-width: 5px;
        }
        .goods-name {
            margin-bottom: 2px;
            font-size: 17px;
        }
        .goods-price {
            font-size: 14px;
            color: gray;
        }
        .goods-select-mark {
            display: none;
            position: relative;
        }
    }

    .goods-active {
        border-width: 5px;
        .goods-select-mark {
            display: block;
            position: absolute;
            right: 0;
            bottom: 0;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 0 30px 30px;
            border-color: transparent transparent $blue-color transparent;
            .el-icon-check {
                color: #fff;
                position: absolute;
                top: 15px;
                left: -17px;
                font-size: 14px;
            }
        }
    }

    .channel-logo {
        height: 40px;
    }

    .channel-name {
        margin-top: 12px;
        font-size: 14px;
    }

    .buy-btn {
        width: 100px;
        height: 40px;
        background: $blue-color;
        @include flex-row-center;
        border-radius: 5px;
        font-size: 15px;
        margin: 30px auto;
        border: none;
    }

    .el-form {
        width: 80%;
        margin: 0 auto;
    }

    .btns {
        @include flex-row-center;
        margin-top: 40px;
    }

    .el-button {
        width: 140px;
        text-decoration: none;
    }

    .el-select {
        width: 100%;
    }

    .method-container {
      width: 100%;
      overflow: hidden;
      margin: 0 auto;
    }

    .swiper-button-prev, .swiper-button-next {
      position: relative;
      margin: -40px 0 0;
    }

    .method-select {
      margin-top: 25px;
      box-sizing: border-box;
      @include flex-row-center;
    }

    .swiper-slide {
      height: 100px;
      @include flex-column-center;
      &:hover {
        cursor: pointer;
      }
    }
</style>



// WEBPACK FOOTER //
// Consume.vue?4bdb330a